import { combineReducers } from "redux";
import CustomerStationFaultsReducer from "./customerStattionsFaultReducer";
import CustomerSuggestionReduer from "./CustomerSuggestion";
import CustomerTrainFaultReduer from "./customerTrainFaults";
import DetailStationFaults from "./DetailStationFaults";
import HeaderReducer from "./Header";
import { tokenReducer, profileReducer } from "./login";
import editCustomerFault from "./editStationFault";
import FaultFormReducer from "./FaultForms";
import reportReducers from './report';
import manageUserReducers from './manageUser';
import usersReducers from './userReducers';

export default combineReducers({
  CustomerStationFaultsReducer,
  CustomerSuggestionReduer,
  CustomerTrainFaultReduer,
  DetailStationFaults,
  HeaderReducer,
  tokenReducer,
  profileReducer,
  reportReducers,
  editCustomerFault,
  FaultFormReducer,
  manageUserReducers,
  usersReducers,
});
